module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_search.7f3a6d9a6e749d1dc4e4bbb490c3ba34.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_search.svg
// module id = 1685
// module chunks = 1